<template>
  <div class="seasidetms_text">
    <h2
      class="vc_custom_heading responsiv-margin-top vc_custom_1515523506195"
      style="text-align: center"
    >
      {{ $t('terms.1.h') }}
    </h2>
    <div class="wpb_text_column wpb_content_element vc_custom_1515523817685">
      <div class="wpb_wrapper">
        <p>
          {{ $t('terms.1.t') }}
        </p>
        <div class="h3">{{ $t('terms.2.h') }}</div>
        <ul>
          <li>
            {{ $t('terms.2.l1') }}
          </li>
          <li>
            {{ $t('terms.2.l2') }}
          </li>
          <li>
            {{ $t('terms.2.l3') }}
          </li>
          <li>
            {{ $t('terms.2.l4') }}
          </li>
          <li>
            {{ $t('terms.2.l5') }}
          </li>
          <li>
            {{ $t('terms.2.l6') }}
          </li>
        </ul>
        <div class="h3">{{ $t('terms.3.h') }}</div>
        <ul>
          <li>
            {{ $t('terms.3.l1') }}
          </li>
          <li>
            {{ $t('terms.3.l2') }}
          </li>
          <li>
            {{ $t('terms.3.l3') }}
          </li>
          <li>
            {{ $t('terms.3.l4') }}
          </li>
        </ul>
        <div class="h3">{{ $t('terms.4.h') }}</div>
        <p>
          {{ $t('terms.4.t') }}
          <br />
          <strong>{{ $t('terms.4.tb') }}</strong>
        </p>
        <ul>
          <li>
            {{ $t('terms.4.l1') }}
          </li>
          <li>
            {{ $t('terms.4.l2') }}
          </li>
          <li>
            {{ $t('terms.4.l3') }}
          </li>
          <li>
            {{ $t('terms.4.l4') }}
          </li>
          <li>
            {{ $t('terms.4.l5') }}
          </li>
          <li>
            {{ $t('terms.4.l6') }}
          </li>
        </ul>
        <div class="h3">{{ $t('terms.5.h') }}</div>
        <p>
          {{ $t('terms.5.t') }}
        </p>
        <ul>
          <li>
            {{ $t('terms.5.l1') }}
          </li>
          <li>
            {{ $t('terms.5.l2') }}
          </li>
          <li>
            {{ $t('terms.5.l3') }}
          </li>
          <li>
            {{ $t('terms.5.l4') }}
          </li>
          <li>
            {{ $t('terms.5.l5') }}
          </li>
        </ul>
        <div class="h3">{{ $t('terms.6.h') }}</div>
        <ul>
          <li>{{ $t('terms.6.l1') }}</li>
          <li>
            {{ $t('terms.6.l2') }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
